/* istanbul ignore file */
import { array as codecArray, boolean as codecBoolean, number as codecNumber, optional as codecOptional, string as codecString, } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
import { Fraction } from './Fraction';
const FrontendSiteSettingsParser = /* #__PURE__ */ parsers.lazy(() => 
/* #__PURE__ */ parsers.object([
    ['ASSIGNMENT_MAX_POINTS_ENABLED', /* #__PURE__ */ codecOptional(codecBoolean)],
    ['DOWNLOAD_EDITOR_FILES_ENABLED', /* #__PURE__ */ codecOptional(codecBoolean)],
    ['GRADING_NOTIFICATIONS_ENABLED', /* #__PURE__ */ codecOptional(codecBoolean)],
    ['HIDE_NO_DEADLINE_ENABLED', /* #__PURE__ */ codecOptional(codecBoolean)],
    ['SHOW_PREMIUM_BADGES', /* #__PURE__ */ codecOptional(codecBoolean)],
    ['INLINE_RUBRIC_VIEWER_ENABLED', /* #__PURE__ */ codecOptional(codecBoolean)],
    ['REGISTER_ENABLED', /* #__PURE__ */ codecOptional(codecBoolean)],
    [
        'ASSIGNMENT_DEFAULT_GRADING_SCALE',
        /* #__PURE__ */ codecOptional(
        /* #__PURE__ */ parsers.exactly('percentage', 'points')),
    ],
    [
        'ASSIGNMENT_DEFAULT_GRADING_SCALE_POINTS',
        /* #__PURE__ */ codecOptional(Fraction),
    ],
    ['ASSIGNMENT_PERCENTAGE_DECIMALS', /* #__PURE__ */ codecOptional(codecNumber)],
    ['ASSIGNMENT_POINT_DECIMALS', /* #__PURE__ */ codecOptional(codecNumber)],
    [
        'ASSISTANT_MODELS',
        /* #__PURE__ */ codecOptional(/* #__PURE__ */ codecArray(codecString)),
    ],
    [
        'CODE_EDITOR_START_ON_ASSIGNMENT_DESCRIPTION',
        /* #__PURE__ */ codecOptional(codecBoolean),
    ],
    [
        'DEFAULT_SUBMISSION_PAGE_TAB',
        /* #__PURE__ */ codecOptional(
        /* #__PURE__ */ parsers.exactly('auto-test', 'code', 'feedback-overview', 'peer-feedback', 'smart')),
    ],
    [
        'HIDE_CODE_EDITOR_OUTPUT_VIEWER_WITH_ONLY_QUIZ_STEPS',
        /* #__PURE__ */ codecOptional(codecBoolean),
    ],
    [
        'HIDE_CODE_EDITOR_FILETREE_CONTROLS_WITH_ONLY_QUIZ_STEPS',
        /* #__PURE__ */ codecOptional(codecBoolean),
    ],
    [
        'NEW_AUTO_TEST_UBUNTU_20_04_BASE_IMAGE_IDS',
        /* #__PURE__ */ codecOptional(/* #__PURE__ */ codecArray(codecString)),
    ],
    [
        'NEW_AUTO_TEST_UBUNTU_24_04_BASE_IMAGE_IDS',
        /* #__PURE__ */ codecOptional(/* #__PURE__ */ codecArray(codecString)),
    ],
    [
        'QUIZ_MINIMUM_QUESTIONS_FOR_DROPDOWN',
        /* #__PURE__ */ codecOptional(codecNumber),
    ],
    [
        'SIMPLE_SUBMISSION_NAVIGATE_TO_LATEST_EDITOR_SESSION',
        /* #__PURE__ */ codecOptional(codecBoolean),
    ],
    [
        'ACCESS_TOKEN_MODAL_WARNING_TIME',
        /* #__PURE__ */ codecOptional(parsers.duration),
    ],
    [
        'ACCESS_TOKEN_TOAST_WARNING_TIME',
        /* #__PURE__ */ codecOptional(parsers.duration),
    ],
    [
        'LOGIN_TOKEN_BEFORE_TIME',
        /* #__PURE__ */ codecOptional(/* #__PURE__ */ codecArray(parsers.duration)),
    ],
    [
        'STUDENT_PAYMENT_MAIN_OPTION',
        /* #__PURE__ */ codecOptional(/* #__PURE__ */ parsers.exactly('coupon', 'stripe')),
    ],
    ['LTI_LOCK_DATE_COPYING_ENABLED', /* #__PURE__ */ codecOptional(codecBoolean)],
    ['BLACKBOARD_ZIP_UPLOAD_ENABLED', /* #__PURE__ */ codecOptional(codecBoolean)],
    ['IS_PEARSON', /* #__PURE__ */ codecOptional(codecBoolean)],
    ['ENTRY_TICKET_FLOW_ENABLED', /* #__PURE__ */ codecOptional(codecBoolean)],
    ['TIER_FREE_AI_ENABLED', /* #__PURE__ */ codecOptional(codecBoolean)],
    ['TIER_FREE_LTI_ENABLED', /* #__PURE__ */ codecOptional(codecBoolean)],
    ['TIER_FREE_ATV1_ENABLED', /* #__PURE__ */ codecOptional(codecBoolean)],
    ['TIER_FREE_JUPYTER_ENABLED', /* #__PURE__ */ codecOptional(codecBoolean)],
    ['TIER_FREE_QUIZ_ENABLED', /* #__PURE__ */ codecOptional(codecBoolean)],
    [
        'TIER_FREE_EXTENDED_RUNTIME_ENABLED',
        /* #__PURE__ */ codecOptional(codecBoolean),
    ],
    [
        'TIER_FREE_UNLIMITED_INSTALL_STEPS_ENABLED',
        /* #__PURE__ */ codecOptional(codecBoolean),
    ],
    ['TIER_FREE_MAX_STUDENTS', /* #__PURE__ */ codecOptional(codecNumber)],
    ['TIER_FREE_MAX_STAFF', /* #__PURE__ */ codecOptional(codecNumber)],
    ['TIER_STARTER_AI_ENABLED', /* #__PURE__ */ codecOptional(codecBoolean)],
    ['TIER_STARTER_LTI_ENABLED', /* #__PURE__ */ codecOptional(codecBoolean)],
    ['TIER_STARTER_ATV1_ENABLED', /* #__PURE__ */ codecOptional(codecBoolean)],
    ['TIER_STARTER_JUPYTER_ENABLED', /* #__PURE__ */ codecOptional(codecBoolean)],
    ['TIER_STARTER_QUIZ_ENABLED', /* #__PURE__ */ codecOptional(codecBoolean)],
    [
        'TIER_STARTER_EXTENDED_RUNTIME_ENABLED',
        /* #__PURE__ */ codecOptional(codecBoolean),
    ],
    [
        'TIER_STARTER_UNLIMITED_INSTALL_STEPS_ENABLED',
        /* #__PURE__ */ codecOptional(codecBoolean),
    ],
    ['TIER_STARTER_MAX_STUDENTS', /* #__PURE__ */ codecOptional(codecNumber)],
    ['TIER_STARTER_MAX_STAFF', /* #__PURE__ */ codecOptional(codecNumber)],
    ['TIER_ADVANCED_AI_ENABLED', /* #__PURE__ */ codecOptional(codecBoolean)],
    ['TIER_ADVANCED_LTI_ENABLED', /* #__PURE__ */ codecOptional(codecBoolean)],
    ['TIER_ADVANCED_ATV1_ENABLED', /* #__PURE__ */ codecOptional(codecBoolean)],
    ['TIER_ADVANCED_JUPYTER_ENABLED', /* #__PURE__ */ codecOptional(codecBoolean)],
    ['TIER_ADVANCED_QUIZ_ENABLED', /* #__PURE__ */ codecOptional(codecBoolean)],
    [
        'TIER_ADVANCED_EXTENDED_RUNTIME_ENABLED',
        /* #__PURE__ */ codecOptional(codecBoolean),
    ],
    [
        'TIER_ADVANCED_UNLIMITED_INSTALL_STEPS_ENABLED',
        /* #__PURE__ */ codecOptional(codecBoolean),
    ],
    ['TIER_ADVANCED_MAX_STUDENTS', /* #__PURE__ */ codecOptional(codecNumber)],
    ['TIER_ADVANCED_MAX_STAFF', /* #__PURE__ */ codecOptional(codecNumber)],
]));
export class FrontendSiteSettings extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return FrontendSiteSettingsParser.decode(input).map(res => new FrontendSiteSettings(res));
    }
    static unsafeDecode(input) {
        return FrontendSiteSettings.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return FrontendSiteSettingsParser.encode(data);
    }
    static schema() {
        return FrontendSiteSettingsParser.schema();
    }
}
